/* Kundu Palai v2 — Shop/Research mode toggle.
   Pure client-side, no reload. Pairs with CSS in kp2.css:
   html[data-kp-mode="shop|research"] [data-kp-only="the-other-one"] { display:none }
*/
(function () {
  function initMode() {
    var params = new URLSearchParams(window.location.search);
    var mode = params.get('mode') === 'research' ? 'research' : 'shop';
    document.documentElement.setAttribute('data-kp-mode', mode);
  }
  // Run as early as possible to avoid a flash of the wrong mode.
  initMode();

  function setMode(mode) {
    document.documentElement.setAttribute('data-kp-mode', mode);
    var url = new URL(window.location.href);
    if (mode === 'research') {
      url.searchParams.set('mode', 'research');
    } else {
      url.searchParams.delete('mode');
    }
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
  }

  function currentMode() {
    return document.documentElement.getAttribute('data-kp-mode') === 'research' ? 'research' : 'shop';
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-kp-toggle]');
    if (!el) return;
    e.preventDefault();
    setMode(currentMode() === 'research' ? 'shop' : 'research');
  });

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-kp-set-mode]');
    if (!el) return;
    var target = el.getAttribute('data-kp-set-mode');
    if (target === 'shop' || target === 'research') {
      setMode(target);
    }
  });

})();

/* Scroll-reveal + parallax utility, used by the About page sections.
   [data-kp2-reveal] fades/rises into view; [data-kp2-parallax] drifts
   slightly on scroll. Safe to call repeatedly (guards against re-init). */
(function () {
  if (window.__kp2RevealInit) return;
  window.__kp2RevealInit = true;

  function initReveal() {
    var els = document.querySelectorAll('[data-kp2-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kp2-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kp2-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var layers = document.querySelectorAll('[data-kp2-parallax]');
    if (!layers.length) return;

    var ticking = false;
    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      layers.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + scrollY) * 0.15;
        el.style.transform = 'translateY(' + Math.min(offset * 0.2, 60) + 'px) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initParallax();
    });
  } else {
    initReveal();
    initParallax();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initParallax();
  });
})();
